import { Summary } from "../hooks/SubscriptionDetail/useSummary";

/**
 * アプリ管理画面「決済設定」をフロントにも反映させるための関数
 */

const DELIVERY_PRICE_FREE_THRESHOLD = 5000;

const calcPrices = (summary: Summary) => {

  const subtotal = summary.totalPrice - summary.deliveryPrice;

  let deliveryPrice = summary.deliveryPrice;
  if (subtotal >= DELIVERY_PRICE_FREE_THRESHOLD) {
    deliveryPrice = 0;
  }

  return {
    subtotal,
    deliveryPrice,
    totalPrice: subtotal + deliveryPrice,
  }
}

export default calcPrices;